module.exports = __webpack_public_path__ + "static/sphere_apex_bg-bd4ad36e046288a4820fa14318a9c068.png";